import { AuthContext, setPlayerAccounts } from '@repo-level/core-front';
import { Spinner } from 'components/Spinner';
import { ModalsContext, ModalType } from 'contexts/modal';
import { localStorageEmail } from 'helpers/common';
import { useFranceLocale } from 'hooks/franceLocale';
import type { FC } from 'react';
import { useContext, useEffect, useMemo } from 'react';
import { useNavigation } from 'react-navi';

type DepositProps = {
  currency?: string;
};

export const DepositModal: FC<DepositProps> = ({ currency }) => {
  const navigation = useNavigation();
  const { isAuthenticated, pendingUser } = useContext(AuthContext);
  const { handleModal } = useContext(ModalsContext);
  const { isFRWithoutStag } = useFranceLocale();

  const hasSavedEmail = !!localStorageEmail.get();

  const setupPlayerAccounts = async () => {
    if (currency && isAuthenticated) {
      try {
        await setPlayerAccounts(currency);
      } catch (err) {
        console.error('Failed to set player accounts', err);
      }
    }
  };

  const redirectPathname = useMemo(() => {
    if (isFRWithoutStag || hasSavedEmail) return '/users/sign_in';
    return '/users/sign_up';
  }, [hasSavedEmail, isFRWithoutStag]);

  const navigateToAuth = async () => {
    await navigation.navigate({
      pathname: redirectPathname,
      search: `back-url=${encodeURIComponent(
        window.location.pathname + window.location.search
      )}`,
    });
  };

  useEffect(() => {
    if (pendingUser) return;

    const run = async () => {
      if (isAuthenticated) {
        await setupPlayerAccounts();
        await navigation.navigate('/');
        handleModal(ModalType.Deposit)();
        return;
      }

      return navigateToAuth();
    };

    void run();
  }, [
    currency,
    isAuthenticated,
    isFRWithoutStag,
    navigation,
    pendingUser,
    handleModal,
  ]);

  return <Spinner center size={64} />;
};
